const ITEMS = [
  "KOMPJUTERSKA DIJAGNOSTIKA",
  "24/7 ŠLEP SLUŽBA",
  "ZAMENA ULJA & FILTERA",
  "ABS KOČIONI SISTEM",
  "PREVOZ VOZILA",
  "CENTRIRANJE TRAPA",
  "SERVIS MENJAČA",
  "VULKANIZER",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative border-y border-white/5 bg-[#0c0c0f] py-5 overflow-hidden">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center font-display text-xl tracking-[0.15em] text-zinc-600 whitespace-nowrap">
                <span className="px-6 hover:text-red-500 transition-colors">{item}</span>
                <span className="text-red-600 text-sm">◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
